import React, { memo } from 'react';
import styled from 'styled-components';
import { borderRadius, display } from 'styled-system';
import Text from './Text';
const StyledPill = styled(Text).withConfig({
  displayName: "Pill__StyledPill",
  componentId: "sc-1dshf1p-0"
})(["", " ", ""], borderRadius, display);
const Pill = /*#__PURE__*/memo(props => /*#__PURE__*/React.createElement(StyledPill, props));
Pill.propTypes = {
  ...borderRadius.propTypes,
  ...display.propTypes,
  ...Text.propTypes
};
Pill.defaultProps = {
  py: 1,
  px: 2,
  fontSize: 1,
  lineHeight: 1,
  display: 'inline-block',
  borderRadius: '100px',
  color: 'white',
  bg: 'darkBlue'
};
Pill.displayName = 'Pill';
export default Pill;